import { GetStaticPaths, GetStaticProps } from 'next'
import { NextSeo } from 'next-seo'

import AccountsGuard from '@/guards/AccountsGuard'
import AssembleLayout from '@/layouts/AssembleLayout'
import SupportLayout from '@/layouts/SupportLayout'
import { siteMiddleware } from '@/lib/middlewares'
import { noIndex } from '@/lib/utils/next-seo.config'
import { SiteData as SiteDataType } from '@/types'
import TicketsView from '@/views/sites/TicketsView'

interface Props {
  initialData?: SiteDataType
}

export default function TicketsPage({ initialData }: Props) {
  const { site: siteData } = initialData || {}

  // SEO
  const commonSEOProps = {
    title: `Atendimentos ${siteData ? ` | ${siteData.title || siteData.seller?.displayName}` : ''}`,
    description: siteData?.description
  }

  return (
    <AssembleLayout
      Layout={SupportLayout}
      View={TicketsView}
      Guard={AccountsGuard}
      initialData={{ initialData }}>
      <NextSeo
        {...commonSEOProps}
        {...noIndex}
      />
    </AssembleLayout>
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: 'blocking' }
}

export const getStaticProps: GetStaticProps = async context => {
  const { data: siteData, error } = await siteMiddleware(context)
  return error?.response?.status === 404
    ? { notFound: true, revalidate: 60 }
    : { props: { initialData: { site: siteData } }, revalidate: 60 }
} // revalidate time in seconds
